export default __webpack_public_path__ + "static/media/gallery_06.f46eca50.jpg";